<template>
    <row>
        <column cols="12" md="7" lg="8">
            <lazy-request-management-card v-if="!eventStore.event.is_managed_by_organizer" :model="eventStore.event" mobile-tile/>
            <card v-else xs-tile sm-tile>
                <card-title>{{ $t('action.contact_organizer') }}</card-title>
                <card-text>
                    <support-form :event="eventStore.event" :email="eventStore.event.email" :phone="eventStore.event.phone" class="pt-8"/>
                </card-text>
            </card>
        </column>

        <column v-if="socialMedia?.has_any || club" cols="12" md="5" lg="4">
            <card v-if="club" xs-tile sm-tile>
                <card-title spaced-content>{{ $t('label.organized_by') }}</card-title>
                <profile-preview :model="club" :to="$web('clubs.show', club._key)" no-spacing flat class="lg:px-24"/>
            </card>

            <social-list v-if="socialMedia?.has_any" :social-media="socialMedia"/>

			<card v-if="imprint" xs-tile sm-tile>
				<card-title>{{ $t('label.imprint') }}</card-title>
				<card-text>
					<user-content :text="imprint" x-small/>
				</card-text>
			</card>
        </column>
    </row>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {useEventStore} from "../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$web, $date} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
if (!eventStore.hasActivePage(EventPageType.Contact)) {
	await navigateTo($web('events.show', route.params.event));
}

let socialMedia = [];
let imprint = null;
let club = null;
try {
	const {data} = await useApiFetch(`/v1/view/events/${eventStore.event.id}/contact`, {
		guest: true,
		params: {
			ts: `${eventStore.event.cache_buster}-${eventStore.event.club.cache_buster}`
		}
	})
	socialMedia = data.socialMedia;
	imprint = data.imprint;
	club = data.club;
} catch (e) {
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.contact.index.title', {event: eventStore.event.display_name})),
	description: t('view.events.contact.index.description', {event: eventStore.event.display_name})
})

useSchemaOrg([
	defineWebPage({
		'@type': 'ContactPage',
	})
])
</script>

